const getFullName = (first = "", lastName = "") => {
  return first.toLowerCase() + " " + lastName.toLowerCase();
};

export { getFullName };
